import { httpClientDrawInfo } from "./http-client";
import { PpDraw } from "../model/draw";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { BetDates } from "@sazka/lotteries/js/models/draw-info/future-draw-dto";
import { LotteryDrawSpecialPrizeGroup, Pager } from "../model/lottery-draw-special-prize-group";
import { LotteryDrawSpecialPrizeList } from "../model/lottery-draw-special-prize-list";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";
import { PastDraw } from "@/lotteries/model/draw-info/past-draw";
import { DrawResults } from "../model/draw-results";
import { QuickLotteryDraw } from "@sazka/lotteries/js/models/draw-info/quick-lottery-draw";

export const fetchDrawList = async (lottery: Lottery): Promise<PastDraw[]> => {
    const datesResponse = await httpClientDrawInfo.get<PastDraw[]>(`/past-draws/${lottery.replace("-", "")}`);
    return datesResponse.data;
};

export const fetchDraw = async (lottery: Lottery, id: number): Promise<PpDraw> => {
    const resultsResponse = await httpClientDrawInfo.get<PpDraw>(`/draws/universal/v2/${lottery}/${id}`);
    return resultsResponse.data;
};

export const fetchSpecialPrizeResults = async (
    lottery: Lottery,
    drawId: number,
    prizeType: string,
    page: number,
    codeFilter = ""
): Promise<Pager<LotteryDrawSpecialPrizeGroup>> => {
    const specialPrizesResponse = await httpClientDrawInfo.get<Pager<LotteryDrawSpecialPrizeGroup>>(
        `draws/special-prize/${lottery}/${drawId}`,
        {
            params: {
                prizeType: prizeType,
                pageNumber: page,
                codeFilter: codeFilter,
            },
        }
    );
    return specialPrizesResponse.data;
};

export const fetchSpecialPrizeResultsCount = async (
    lottery: Lottery,
    id: number,
    codeFilter = ""
): Promise<LotteryDrawSpecialPrizeGroup[]> => {
    const specialPrizesResponse = await httpClientDrawInfo.get<LotteryDrawSpecialPrizeGroup[]>(
        `draws/special-prize/${lottery}/${id}`,
        {
            params: {
                codeFilter: codeFilter,
            },
        }
    );
    return specialPrizesResponse.data;
};

export const fetchSpecialPrizeListResults = async (
    lottery: Lottery,
    from: Date,
    to: Date,
    page: number
): Promise<LotteryDrawSpecialPrizeList[]> => {
    const specialPrizesResponse = await httpClientDrawInfo.get<LotteryDrawSpecialPrizeList[]>(
        `draws/special-prize/list/${lottery}/${page}`,
        {
            params: {
                from: `${from.toISOString().split("T")[0]}`,
                to: `${to.toISOString().split("T")[0]}`,
            },
        }
    );
    return specialPrizesResponse.data;
};

export const fetchSpecialPrizeListResultsCount = async (lottery: Lottery, from: Date, to: Date): Promise<number> => {
    const specialPrizesResponse = await httpClientDrawInfo.get<number>(`draws/special-prize/list/count/${lottery}`, {
        params: {
            from: `${from.toISOString().split("T")[0]}`,
            to: `${to.toISOString().split("T")[0]}`,
        },
    });
    return specialPrizesResponse.data;
};

export const fetchBetDates = async (lottery: Lottery): Promise<BetDates> => {
    const datesResponse = await httpClientDrawInfo.get<BetDates>(`/future-draws/bet/${lottery}`);
    return datesResponse.data;
};

export const fetchQuickLotteryResults = async (lottery: Lottery, count = 5): Promise<QuickLotteryDraw[]> => {
    const datesResponse = await httpClientDrawInfo.get<QuickLotteryDraw[]>(`/draws/quick-lottery/${lottery}`, {
        params: {
            count: count,
        },
    });
    return datesResponse.data;
};

export const fetchQuickLotteryResultsByDates = async (
    lottery: Lottery,
    from: Date = null,
    to: Date = null
): Promise<QuickLotteryDraw[]> => {
    const datesResponse = await httpClientDrawInfo.get<QuickLotteryDraw[]>(`/draws/quick-lottery/${lottery}/results`, {
        params: {
            from: from ? DateTimeUtils.getLocalIsoString(from) : null,
            to: to ? DateTimeUtils.getLocalIsoString(to) : null,
        },
    });
    return datesResponse.data;
};

export const fetchLastResults = async (game: Lottery): Promise<DrawResults> => {
    const response = await httpClientDrawInfo.get<DrawResults>(`/draws/universal/${game}/last-results`);
    return response.data;
};

export const fetchResultsById = async (game: Lottery, id: number): Promise<DrawResults> => {
    const response = await httpClientDrawInfo.get<DrawResults>(`/draws/universal/${game}/${id}/results`);
    return response.data;
};
